module.exports = "https://www.gc-pro.gnp.com.mx/9ecb58e5cfb6175081e92c6039b67f1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/eye-view.svg
// module id = 8106
// module chunks = 0